export const dynamicSortOfObjects = ( arrayOfObjs , comparison, isDate, isAscending = true, isNumber = false) => {
    if (isDate) {
        if(isAscending) {
            return arrayOfObjs.sort(function(a, b) { return new Date(a[comparison]) - new Date(b[comparison]) ;});
        } else {
            return arrayOfObjs.sort(function(a, b) { return new Date(b[comparison]) - new Date(a[comparison]) ;});
        }
    } else if(isNumber) {
        if(isAscending) {
            return arrayOfObjs.sort(function(a, b) {
                return parseInt(a[comparison]) - parseInt(b[comparison]);
            });
        } else {
            return arrayOfObjs.sort(function(a, b) {
                return parseInt(b[comparison]) - parseInt(a[comparison]);
            });
        }

    } else {
        if(isAscending) {
            return arrayOfObjs.sort(function(a, b) {
                const aComparison = a[comparison].toUpperCase();
                const bComparison = b[comparison].toUpperCase();
                if (aComparison > bComparison) return 1;
                if(bComparison > aComparison) return -1;

                return 0;
            });
        } else {
            return arrayOfObjs.sort(function(a, b) {
                const aComparison = a[comparison].toUpperCase();
                const bComparison = b[comparison].toUpperCase();
                if (aComparison < bComparison) return 1;
                if(bComparison < aComparison) return -1;

                return 0;
            });
        }
    }
};